// extracted by mini-css-extract-plugin
export default {"infractionList":"infraction_list_infractionList__rMb7c","Mui-focused":"infraction_list_Mui-focused__yN1nK","label":"infraction_list_label__fS3jZ"};